export const tips = [
  {
    id: 1,
    title: 'Perfect Your Grip',
    description: 'The foundation of every great pitch starts with the proper grip. Experiment with different finger placements on the seams to find what gives you the most control and movement. Remember, consistency in your grip leads to consistency in your results.',
    icon: 'ri-hand-coin-line',
    category: 'Mechanics',
  },
  {
    id: 2,
    title: 'Mental Preparation',
    description: 'Baseball is 90% mental. Before every game, visualize your success on the mound. Picture yourself executing perfect pitches and dominating batters. This mental rehearsal builds confidence and prepares your mind for high-pressure situations.',
    icon: 'ri-brain-line',
    category: 'Mindset',
  },
  {
    id: 3,
    title: 'Leg Drive Power',
    description: 'Your legs are the engine of your pitching motion. Focus on driving powerfully off the rubber with your back leg. This generates the momentum and velocity that translates through your entire kinetic chain to the ball.',
    icon: 'ri-run-line',
    category: 'Mechanics',
  },
  {
    id: 4,
    title: 'Study the Hitters',
    description: 'Knowledge is power. Spend time analyzing opposing batters\' tendencies, weaknesses, and hot zones. Understanding what they struggle with allows you to attack with confidence and exploit their vulnerabilities.',
    icon: 'ri-eye-line',
    category: 'Strategy',
  },
  {
    id: 5,
    title: 'Recovery is Key',
    description: 'Your arm is your most valuable asset. Prioritize proper recovery between outings with ice, stretching, and adequate rest. Listen to your body and never push through pain. A healthy arm is a dominant arm.',
    icon: 'ri-heart-pulse-line',
    category: 'Recovery',
  },
  {
    id: 6,
    title: 'Develop Your Secondary Pitches',
    description: 'While a great fastball is essential, elite pitchers have multiple weapons. Dedicate time to developing a reliable breaking ball and changeup. The more pitches you can command, the more unpredictable you become.',
    icon: 'ri-basketball-line',
    category: 'Mechanics',
  },
  {
    id: 7,
    title: 'Control Your Breathing',
    description: 'In high-pressure moments, controlled breathing keeps you calm and focused. Take deep breaths between pitches to lower your heart rate and clear your mind. This simple technique can be the difference between success and failure.',
    icon: 'ri-lungs-line',
    category: 'Mindset',
  },
  {
    id: 8,
    title: 'Film Study Routine',
    description: 'Watch film of your performances regularly. Analyze your mechanics, pitch selection, and results. Identify patterns in what works and what doesn\'t. Self-awareness through film study accelerates improvement.',
    icon: 'ri-video-line',
    category: 'Strategy',
  },
  {
    id: 9,
    title: 'Build Core Strength',
    description: 'A strong core is essential for generating power and maintaining balance throughout your delivery. Incorporate planks, rotational exercises, and medicine ball work into your training routine to build a rock-solid foundation.',
    icon: 'ri-shield-star-line',
    category: 'Training',
  },
];
